import { solidstate } from ":setup/qstate";
import type { GradingData, TeamData } from "../../_model";
import { Show, createEffect, createMemo, untrack } from "solid-js";
import { Button } from ":ui/form";

export type Props = {
  data: GradingData;
  entity: TeamData;
  onSubmit: (props: { scores: Record<string, number> }) => void;
  onNext?: () => void;
  onGraded?: (props: { score: number; graded: boolean }) => void;
  class?: string;
};
export function Scoring(props: Props) {
  const c_keys = props.data?.c_keys;
  const criteria = props.data?.criteria;
  const scores_tracker = solidstate.create({} as { [k: string]: any });
  const scores = createMemo(() => props.entity?.scores);
  const graded = createMemo(() => {
    const graded = props.entity?.eval_id !== null && props.entity?.eval_id !== undefined;
    const score = scores()?.total;
    props.onGraded?.({ score, graded });
    return graded;
  });
  const scores_tracker_keys = createMemo(() => scores_tracker.value && Object.keys(scores_tracker.value));
  const btn_status = createMemo(() => (scores_tracker_keys()?.length >= c_keys.length ? "ready" : "awaiting"));

  createEffect(() => {
    // update scores_tracker
    const _scores = scores();
    const _graded = untrack(() => graded());
    scores_tracker.set((s) => {
      const f = {};
      c_keys.forEach((q) => {
        if (_graded && !f?.[q]) {
          f[q] = _scores[q];
        }
      });
      return f;
    });
  });

  function onChange(e: Event, q: string | number) {
    const value = (e.target as any).value;
    const value_as_string = String(value);
    scores_tracker.set((s) => {
      const n = { ...s };
      if (value_as_string == undefined || value_as_string.length <= 0) {
        delete n[q];
      } else {
        n[q] = Number(value);
      }
      return n;
    });
  }

  async function onSubmit() {
    const scores = scores_tracker.unwrap;
    console.log("on submit :: ");
    return props.onSubmit?.({ scores });
  }

  async function onSubmitAndNext() {
    return onSubmit().then(() => {
      props.onNext?.();
    });
  }

  return (
    <section class="grid grid-cols-1 grid-rows-[1fr_5%_7%] w-full h-full gap-1.5 content-between overflow-hidden <sm:(grid-rows-[1fr_7%_12%])">
      <Show
        when={c_keys && c_keys.length > 0}
        fallback={"Unfortunately, There are no evaluation criteria, contact platform support to resolve this!"}
      >
        <section class="flex flex-col w-full h-full gap-2 px-1 py-2 rounded-md !overflow-y-auto overflow-x-hidden">
          {c_keys.map((q, i) => {
            const c = criteria[q];
            const name = c?.name;
            return (
              <div class="flex flex-col w-full h-full px-2 py-2 bg-bg-alt rounded-xl text-0.7em">
                <span class="flex flex-row w-full h-fit capitalize font-bold text-1em">{String(name)}</span>
                <div class="grid grid-cols-[80%_17%] w-full h-50px gap-2 items-center justify-between overflow-hidden <sm:(!grid-cols-[77%_20%])">
                  <input
                    class="w-full !h-0 !accent-brand py-2 outline-none ring-0 border-0 cursor-pointer"
                    type="range"
                    min={c.min}
                    max={c.max}
                    step={1}
                    value={scores_tracker.value?.[q] ?? 0}
                    oninput={(e) => {
                      e.preventDefault();
                      onChange(e, q);
                    }}
                  />
                  <span class="flex w-full h-full items-center justify-center text-center self-center text-brand">
                    {scores_tracker.value?.[q] == undefined ? "grade" : scores_tracker.value?.[q]}
                  </span>
                </div>

                <div class="grid grid-cols-[49%_24%_24%] w-full h-fit items-end gap-x-1 justify-between children:(capitalize)">
                  <div class="flex flex-row w-full gap-x-2 <sm:(!flex-col)">
                    <span class="opacity-55">Previous</span>
                    <span class="!capitalize">{!scores() ? "Unevaluated" : scores()[q]}</span>
                  </div>
                  <div class="flex flex-row w-full gap-x-2 <sm:(!flex-col)">
                    <span class="opacity-55">Min</span>
                    <span class="!capitalize">{c.min}</span>
                  </div>
                  <div class="flex flex-row w-full gap-x-2 <sm:(!flex-col)">
                    <span class="opacity-55">Max</span>
                    <span class="!capitalize">{c.max}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
        <section class="flex flex-row w-full h-full justify-between items-center text-0.8em px-2 overflow-hidden <sm:(text-0.7em)">
          <p class="">Grade</p>
          <p class="bg-brand-alt text-brand px2 rounded-xl text-center ">{graded() ? scores()?.total : "Not Graded"}</p>
        </section>
        <section class="grid grid-cols-[1fr_1fr] w-full h-full gap-2">
          <Button
            controls={[]}
            onSubmit={onSubmit}
            class="form-btn "
            triggers={{
              manualStatus: btn_status() === "ready" ? "valid" : "invalid",
            }}
            statusInvalid={"Finish Grading"}
            statusValid={graded() ? "Update" : "Submit"}
          />
          <Button
            controls={[]}
            onSubmit={onSubmitAndNext}
            class="form-btn"
            // triggers={{
            //   manualStatus: btn_status() === "ready" ? "valid" : "invalid",
            // }}
            events={{
              onSetButtonEnabledState(enable_button, status) {
                return btn_status() === "ready" ? true : false;
              },
            }}
            statusInvalid={"Finish Grading"}
            statusValid={graded() ? "Update And Next" : "Submit And Next"}
          />
        </section>
      </Show>
    </section>
  );
}
